<div>
  <div
    bsModal
    #createVersionModal="bs-modal"
    class="modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="dialog-child-name">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header" style="border-bottom: 0 !important; padding-bottom: 0">
          <button type="button" class="close pull-right" aria-label="Close" (click)="cancel()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label for="name">User</label>
            <select [(ngModel)]="selectedAdmin" class="form-control">
              <option *ngFor="let admin of adminArray" [value]="admin.id">{{ admin.name }}</option>
            </select>
          </div>
          <br />
          <div style="text-align: right">
            <button type="button" class="btn aru btn-secondary" (click)="cancel()">Cancel</button>
            <button
              *ngIf="!isPreviewLetter"
              [disabled]="!selectedAdmin"
              type="button"
              class="btn aru btn-primary"
              (click)="createVersion()">
              Create new version
            </button>
            <button
              *ngIf="isPreviewLetter"
              [disabled]="!selectedAdmin"
              type="button"
              class="btn aru btn-primary"
              (click)="previewRecLetter()">
              Preview
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
